<template>
	<div class="page-wrapper" >
		<nav class="navbar navbar-expand-lg bg-light navbar-light fixed-top navbar-center" id="navbar">

			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarToggler">

				<ul class="navbar-nav mr-auto ml-auto mt-2 mt-lg-0">
					<li class="nav-item">
						<a class="navbar-brand" v-scroll-to="'#home'" href="#">
							<img src="@/assets/img/ic_home.svg" width="30" height="30" alt=""/>
						</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" v-scroll-to="'#about'" href="#body" @click="scrollIntoView">ABOUT</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" v-scroll-to="'#menu'" href="#menu">MENU</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" v-scroll-to="'#book'" href="#">BOOK A TABLE</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" v-scroll-to="'#gallery'" href="#">GALLERY</a>
					</li>
					<li class="nav-item" v-if="configs.length > 1">
						<a class="nav-link" v-on:click="moveToLanding()">BRANCHES</a>
					</li>
				</ul>
			</div>

		</nav>
		<div class="section main-background" id="home" v-bind:style="{backgroundImage: 'url(' + currentImage + ')'}">
      <div class="logo-box">
				<div class="logo-container">
					<img class="logo" v-bind:src="config.logo"/>
					<h3 v-if="configs.length > 1" class="logo-branch">{{branch}}</h3>
				</div>

<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <h4>We fully reopen from 4th July</h4>-->
<!--            <br>-->
<!--            <h6>Currently Deliveroo and takeaway available</h6>-->
<!--            <p><a href="https://deliveroo.co.uk/menu/reading/reading-central/gooi-nara#" target="_blank"><img style="max-width:50%;" src="https://borium.s3.eu-west-2.amazonaws.com/gooinara/deliveroo.png"/></a></p>-->
<!--&lt;!&ndash;            <p>We hope everyone stays well and see you soon.</p>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
				<div class="row">
					<div class="col-12 col-md-6">
						<h4>Opening Hours</h4>
						<p>Monday<br>{{config.openMonday}}</p>
						<p>Tuesday-Sunday<br>{{config.openTueSat}}</p>
<!--						<p>Sunday {{config.openSun}}</p>-->
            <template v-if="config.holidays != undefined && config.holidays.length > 0" v-for="(holiday, index) in config.holidays">
              <p v-if="holiday.type !== 'full_book' && holiday.type !== 'day_full' && holiday.type !== 'period_full'">
                <span v-if="holiday.description != undefined && holiday.description.length > 0">{{holiday.description}}</span><span v-else>{{holiday.text}}</span> </p>
            </template>


            <a href="https://eemo.app/restaurant/26/takeaway" target="_blank">
              <div class="eemo-button">
                <span><img src="../assets/img/eemo-logo-small.png" height="40px;"></span>
               Click & Collect <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </div>
            </a>
            <hr>

            <h3><a href="https://deliveroo.co.uk/menu/reading/reading-central/gooi-nara" target="_blank" rel="noopener noreferrer"><strong><i class="fa fa-arrow-circle-right" aria-hidden="true"></i> DELIVERY</strong></a></h3>
            <p>Monday<br>{{config.openMonday}}</p>
            <p>Tuesday-Sunday<br>{{config.openTueSat}}</p>
					</div>
					<div class="col-12 col-md-6">
						<p>{{config.address1}}<br>{{config.address2}} {{config.postCode}}</p>
						<p>{{config.contact}}<br>{{config.contact2}}</p>
						<hr>
						<p></p>
						<ul class="qicons_list">
							<li class="qicon">
								<img title="fish" src="@/assets/img/fish.svg">
							</li>
							<li class="qicon">
								<img title="sushi" src="@/assets/img/sushi.svg">
							</li>
							<li class="qicon">
								<img title="vegetarian" src="@/assets/img/vegetarian.svg">
							</li>
							<li class="qicon">
								<img title="tea" src="@/assets/img/tea.svg">
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid text-center" id="about">
			<div class="anchor" ></div>
			<div class="row">
				<div class="container">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section" v-bind:src="config.logoSmall">
								ABOUT
							</h2>
							<div class="container">
								<div class="row">
									<div class="col-12 col-sm-4 section-img" v-bind:style="{ backgroundImage: 'url(' + config.aboutImage + ')' }"></div>
									<div class="col-12 col-sm-8 section-content">
										<p>Welcome to Gooi Nara! Treat yourself to something different today at our restaurant on Whitley Street, close to the university. Our premium Korean barbeque promises a fun and social time with your friends as you grill our wide array of veggies, meat and seafood directly at your table.</p>
										<p>Our premium Korean barbeque promises a fun and social time with your friends as you grill our wide array of veggies, meat and seafood directly at your table.</p>
										<p>That’s not all – we also offer various Korean specialities including rice, noodle, soup dishes and sides to complete your meal. Visit us in Reading for a taste of authentic Korean specialities at wallet-friendly prices. We’re open seven days a week for lunch and dinner, and we can’t wait to serve you!</p>
										<p>Visit us in Reading for a taste of authentic Korean specialities at wallet-friendly prices. We’re open seven days a week for lunch and dinner, and we can’t wait to serve you!</p>
                    <p>We’re open six days a week for lunch and dinner, and we can’t wait to serve you!</p>
                    <p><strong>For Delivery -&gt; <a href="https://deliveroo.co.uk/menu/reading/reading-central/gooi-nara" target="_blank" rel="noopener noreferrer">Click Here</a></strong></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="container-fluid text-center" id="menu">
			<div class="row">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section" v-bind:src="config.logoSmall">
								MENU
							</h2>
							<div class="container">
								<div class="col-12">
									<a v-bind:href="config.menuLunch" target="_blank"><div class="btn btn-primary ss-btn">Menu 1</div></a>
									<a v-bind:href="config.menuDinner" target="_blank"><div class="btn btn-primary ss-btn">Menu 2</div></a>
									<a v-bind:href="config.menuDrink" target="_blank" style="display: none;"><div class="btn btn-primary ss-btn">Drink</div></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="container-fluid text-center" id="gallery">
			<div class="row">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section" v-bind:src="config.logoSmall">
								GALLERY
							</h2>
							<div class="container">
								<ul class="gallery">
									<li v-for="(item, index) in config.galleryImageList" class="gallery-item col-4 col-sm-3">
										<a v-bind:href="item"  v-bind:style="{ backgroundImage: 'url(' + item + ')' }"></a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>




		<div class="container-fluid text-center" id="book">
			<div class="row">
				<div class="container no-padding">
					<div class="col-12 text-center content-wrap">
						<div class="content-box">
							<h2>
								<img class="logo-section" v-bind:src="config.logoSmall">
								BOOKING
							</h2>
							<div class="container content-frame">
								<div class="row">
									<div class="col-12 col-sm-6 text-left">
										<i class="fas fa-map-marker"></i>
                    <p>{{config.address1}}, {{config.address2}} {{config.posCode}}</p>
										<br>
										<i class="fas fa-phone"></i><br>
                    <p>{{config.contact}}<br>{{config.contact2}}</p>

										<hr>

									</div>
									<div class="col-12 col-sm-6">
										<div class="container text-left">
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Name
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-name" type="text" class="form-control col-12" name="your-name" aria-required="true" aria-invalid="true" placeholder="Your Name" v-model="formName"/>
												</div>
												<span id="form-name-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Contact
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-phone" type="text" class="form-control col-12" name="your-phone" aria-required="true" aria-invalid="true" placeholder="Phone Number" v-model="formPhone"/>
												</div>
												<span id="form-contact-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Email
												</div>
												<div class="col-12 col-sm-9">
													<input id="form-email" type="text" class="form-control col-12" name="your-email" aria-required="true" aria-invalid="true" placeholder="Your Email" v-model="formEmail"/>
												</div>
												<span id="form-email-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Date
												</div>
												<div class="col-12 col-sm-9">
													<input type="date" class="form-control col-12" v-model="formDate" @change="onBookingDateSelected()"/>
												</div>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													For
												</div>
												<div class="col-12 col-sm-9">
													<select class="form-control" v-model="formHeadCount">
														<option v-for="i in (2, config.bookingMax)" :value="i">{{i}}</option>
													</select>
												</div>
											</div>
											<div class="row form-group">
												<div class="col-12 col-sm-3">
													Time
												</div>
												<div class="col-12 col-sm-9">
													<select class="form-control" v-model="formTime">
														<option v-for="(slot, index) in bookingTimeSlots" :value="slot">{{slot}}</option>
													</select>
												</div>
											</div>
											<div class="form-group  text-left">
												<textarea id="form-message" class="form-control col-12" name="your-text" aria-required="true" aria-invalid="true" placeholder="Your Message" rows="5" v-model="formMessage"></textarea>
												<span id="form-message-alert"role="alert" class="alert hide">The field is required</span>
											</div>
											<div class="form-group text-left">
												<button type="button" class="btn btn-primary" v-on:click="sendForm">Make Reservation</button>
											</div>
										</div>
									</div>
									<div class="col-12 section-map">

										<div class="map-container" id="mapName">
											<iframe :src="config.map" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
											<gmap-map
										      :center="center"
										      :zoom="15"
										      style="width:100%; height:100%;display:none;">
										    </gmap-map>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="progressView" v-if="showProgress==true">

			<div class="center-container container">
				<div class="row">
					<div class="col-4">
						<div class="loader"></div>
					</div>
					<div class="col-8">
						<div class="center-container text-left">
							{{progressMessage}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-dialog/>
	</div>
</template>

<script>
require('@/assets/css/styles.css')

import axios from 'axios';

export default {
  name: 'Home',
  data () {
    return {
		center: { lat: 51.4333997, lng:-0.5141324},

		msg: 'Welcome to Sushi Nara Staines',
        images:[],
        currentNumber:0,
        timer:null,
		formName:'',
		formEmail:'',
		formPhone:'',
		formSubject:'',
		formMessage:'',

		formPhoneNumber:'',
		formDate:'',
		formTime:'',
		formHeadCount:'',
		bookingTimeSlots:[],
		branch: 'Guildford',
		configs: false,
		config: false,
		otherConfig: false,

		showProgress:false,
		progressMessage:'Please Wait',
    }

  },
 	created: function() {
 		this.branch = "GooiNara";
 		this.getConfiguration();
 	},
	mounted: function() {
	/*
		const element = document.getElementById(this.mapName)

		const options = {
			zoom: 14,
			center: new google.maps.LatLng(51.501527,-0.1921837)
		}
		const map = new google.maps.Map(element, options);
		var infoWindow = new google.maps.InfoWindow;
		*/
	},
    computed: {
        currentImage: function() {
            return this.images[Math.abs(this.currentNumber) % this.images.length];
        }
    },
  	methods: {
        startRotation: function() {
            this.timer = setInterval(this.next, 3000);
        },

        stopRotation: function() {
            clearTimeout(this.timer);
            this.timer = null;
        },
        next: function() {
            this.currentNumber += 1
        },
        prev: function() {
            this.currentNumber -= 1
        },
  		showProgressView: function(msg) {
	  		console.log("showProgress");
	  		this.$data.progressMessage = msg;
	  		this.$data.showProgress = true;
	  	},
	  	dismissProgressView: function() {
	  		console.log("stopProgress");
	  		this.$data.showProgressLoading = false;
	  		this.$data.showProgress = false;
	  	},
	  	changeConfig: function(branch) {
	  		this.$data.otherConfig = this.$data.config;
	  		this.$data.config = this.$data.configs[branch];


	  		this.$data.branch = this.$data.config.branch;

	  		console.log("Other branch is now " + this.$data.otherConfig.branch);
	  	},
        getDateForm: function(time) {
            var dd = String(this.appendLeadingZeroes(time.getDate()));
            var mm = String(this.appendLeadingZeroes(time.getMonth() + 1)); //January is 0!
            var yyyy = time.getFullYear();
            return yyyy + '-' + mm + '-' + dd;
        },
        getLocalDayForm: function(time) {
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return months[time.getMonth()] + ' ' + time.getDate();
        },
  		getConfiguration: function() {
  			var self = this;
  			var url = process.env.ROOT_API + '?type=config';

  			axios.get(url)
  			.then(response => {
  				// console.log(response.data);
  				var data = response.data;
  				if(data.result == true) {
  					self.$data.configs = data.config;
  					for(var branchKey in self.$data.configs) {
  						self.$data.configs[branchKey].galleryImageList = [];
  						for(var key in self.$data.configs[branchKey]) {
  							if(key.startsWith("galleryImg")) {
  								self.$data.configs[branchKey].galleryImageList.push(self.$data.configs[branchKey][key]);
  							}
  						}
  						self.$data.configs[branchKey].holidays = [];
              if(self.$data.configs[branchKey].events != undefined) {
                  for(var i = 0 ; i < self.$data.configs[branchKey].events.length ; i++) {
                      // console.log("Event check " + branchKey + " " + i);
                      var event = self.$data.configs[branchKey].events[i];
                      // console.log(event);
                      var from = new Date(event.from);
                      var to = new Date(event.to);
                      var duration = (to-from)/1000/60/60;
                      var day = self.getLocalDayForm(from);
                      // console.log(day + " duration " + duration);
                      var dayText = self.getDateForm(from);
                      var holiday = {
                          'date': dayText,
                          'from': from,
                          'to': to,
                          'description':'',
                      };
                      if(event.description != undefined && event.description.length > 0) {
                        holiday.description = event.description;
                      }
                      if(duration == 24) {
                          var h = day + " Closed";
                          holiday.text = holiday.description;
                          holiday.type = 'full';
                      } else if(duration > 24) {
                          to.setSeconds(to.getSeconds() -1);

                          holiday.text = "Close from " + this.getDateForm(from) + " to " + this.getDateForm(to);
                          holiday.to = to;
                          holiday.type = 'period';
                      } else {
                          if(from.getHours() == 0) {
                              var h = day + " Open from " + self.appendLeadingZeroes(to.getHours()) + ':' + self.appendLeadingZeroes(to.getMinutes());
                              holiday.text = h;
                              holiday.type = 'partial';
                          } else {
                              var h = day + " Close at " + self.appendLeadingZeroes(from.getHours()) + ':' + self.appendLeadingZeroes(from.getMinutes());
                              holiday.text = h;
                              holiday.type = 'partial';
                          }
                      }
                      self.$data.configs[branchKey].holidays.push(holiday);
                      // console.log("EVENT " + event.title + ' ' + from + '~' + to + ' duration ' + duration);
                  }
              }
              if(self.$data.configs[branchKey].full != undefined) {
                for(var i = 0 ; i < self.$data.configs[branchKey].full.length ; i++) {
                  // console.log("Event check " + branchKey + " " + i);
                  var event = self.$data.configs[branchKey].full[i];
                  // console.log(event);
                  var from = new Date(event.from);
                  var to = new Date(event.to);
                  var duration = (to-from)/1000/60/60;
                  var day = self.getLocalDayForm(from);
                  // console.log(day + " duration " + duration);
                  var dayText = self.getDateForm(from);
                  var holiday = {
                    'date': dayText,
                    'from': from,
                    'to': to,
                    'description':'',
                    'type':'full_book',
                    'text':'',
                  };
                  if(event.description != undefined && event.description.length > 0) {
                    holiday.description = event.description;
                  }
                  if(duration == 24) {
                    var h = day + " Fully booked";
                    holiday.text = h;
                    holiday.type = 'day_full';
                  } else if(duration > 24) {
                    to.setSeconds(to.getSeconds() -1);
                    holiday.type = 'period_full';
                    holiday.text = "Fully Booked from " + this.getDateForm(from) + " to " + this.getDateForm(to);
                    holiday.to = to;
                  } else {
                    holiday.text = "Time you choose is fully booked";


                  }
                  self.$data.configs[branchKey].holidays.push(holiday);
                  // console.log("Event added");
                  // console.log(holiday);
                }
              }
  					}
  					self.$data.config = self.$data.configs[self.$data.branch];
  					//self.$data.otherConfig = self.$data.configs['Staines'];
              self.$data.images = self.$data.config.mainImage.split(',');
              self.startRotation();

  				} else {

  				}
  			})
  			.catch(error=>{
            console.log(error);
  			});
  		},
  		initialiseForm: function() {
  			this.$data.formName = '';
  			this.$data.formEmail = '';
  			this.$data.formSubject = '';
  			this.$data.formMessage = '';
  			this.$data.formDate = '';
        this.$data.formTime = '';
        this.$data.formPhone = '';
        this.$data.formHeadCount = '';
  		},
  		getBookingDayKey: function(day) {
  			if(day == 0) {
  				return 'bookingSun';
  			} else if(day == 1) {
  				return 'bookingMon';
  			} else if(day == 2) {
  				return 'bookingTue';
  			} else if(day == 3) {
  				return 'bookingWed';
  			} else if(day == 4) {
  				return 'bookingThu';
  			} else if(day == 5) {
  				return 'bookingFri';
  			} else if(day == 6) {
  				return 'bookingSat';
  			}
  			return false;
  		},
  		appendLeadingZeroes: function(n){
			if(n <= 9){
				return "0" + n;
			}
			return n
		},
  		onBookingDateSelected: function() {
  			this.$data.bookingTimeSlots = [];
  			var selectedDate = this.$data.formDate;
  			if(selectedDate.length == 0) {
  				return;
  			}

  			var d = new Date(selectedDate);
  			console.log("Selected day is " + this.getBookingDayKey(d.getDay()));
  			var bookingTimeRange = this.$data.config[this.getBookingDayKey(d.getDay())];
  			if(bookingTimeRange.length == 0) {
  				console.log("Cannot choose");
  				this.$modal.show('dialog',{
            title:"CANNOT BOOK",
            text: "Please choose different date"
          })
  				this.$data.formDate = '';
  				return;
  			}
  			if(this.$data.config.holidays != undefined && this.$data.config.holidays.length > 0) {
            for (var i = 0; i < this.$data.config.holidays.length; i++) {
                // console.log("check date " + selectedDate);
                // console.log(this.$data.config.holidays[i]);
                if(this.$data.config.holidays[i].type === 'period' || this.$data.config.holidays[i].type === 'period_full') {
                  if(selectedDate >= this.getDateForm(this.$data.config.holidays[i].from) && selectedDate <= this.getDateForm(this.$data.config.holidays[i].to)) {
                    this.$modal.show('dialog',{
                      title:this.$data.config.holidays[i].text,
                      text: this.$data.config.holidays[i].description.length>0?this.$data.config.holidays[i].description:"Please choose different date",
                    })
                    this.$data.formDate = '';
                    return;
                  }

                }
                if(this.$data.config.holidays[i].type !== 'full' && this.$data.config.holidays[i].type !== 'day_full') {
                    // console.log("not full day event " + this.$data.config.holidays[i].type);
                    continue;
                }
                if(this.$data.config.holidays[i].date == selectedDate) {
                    // console.log("date is the same");
                    this.$modal.show('dialog',{
                        title:this.$data.config.holidays[i].text,
                        text: "Please choose different date"
                    })
                    this.$data.formDate = '';
                    return;
                } else {
                  // console.log("check date is not the same " + selectedDate + " " + this.$data.config.holidays[i].date);
                }
            }
        }
          var isToday = false;
          var currentHour = 0;
  			var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
          var limitTime = new Date(today.getTime() + 60*60*1000);

        today = yyyy + '-' + mm + '-' + dd;



        if(selectedDate == today) {
            console.log("IT is today");
            isToday = true;
            currentHour = today
        }

  			var timeRanges = bookingTimeRange.split(',');

  			console.log("interval " + this.$data.config.bookingInterval);
  			console.log("timeRange " + timeRanges + " arary " + timeRanges.length);
  			let holiday = false;
        if(this.$data.config.holidays != undefined && this.$data.config.holidays.length > 0) {
            for (var i = 0; i < this.$data.config.holidays.length; i++) {
                if(this.$data.config.holidays[i].date == selectedDate) {
                    holiday = this.$data.config.holidays[i];
                    break;
                }
            }
        }
  			for(var i = 0 ; i < timeRanges.length ; i++) {
  				var range = timeRanges[i];
  				console.log("Range " + range);
  				var timeRange = range.split('-');
  				//var continue = true;
  				var time = timeRange[0];
  				console.log("H " + time.substr(0,2));
  				console.log("M " + time.substr(2));
  				d.setHours(parseInt(time.substr(0,2)));
  				d.setMinutes(parseInt(time.substr(2)));

  				var endTime = new Date(selectedDate);
  				endTime.setHours(parseInt(timeRange[1].substr(0,2)));
  				endTime.setMinutes(parseInt(timeRange[1].substr(2)));
  				while(d < endTime) {
  					console.log(d.getHours() + ' ' + d.getMinutes());
  					var timeSlot = this.appendLeadingZeroes(d.getHours()) + ":" + this.appendLeadingZeroes(d.getMinutes())

            if(d > limitTime) {
              let add = true;
              if(this.$data.config.holidays != undefined && this.$data.config.holidays.length > 0) {
                for (var hi = 0; hi < this.$data.config.holidays.length; hi++) {
                  if(d > this.$data.config.holidays[hi].from && d < this.$data.config.holidays[hi].to) {
                    add = false;
                    break;
                  }
                }
              }
                if(add == true) {
                    this.$data.bookingTimeSlots.push(timeSlot);
                }
            }

  					d.setMinutes(d.getMinutes() + parseInt(this.$data.config.bookingInterval));

  				}
  			}

  		},
        validateEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
		sendForm: function() {
			console.log("sendForm");
			this.showProgressView("Checking Request");
			var verified = true;
			var message = '';
			if(this.$data.formName.length == 0) {
				$("#form-name-alert").removeClass("hide");
				verified = false;
				message += 'Name is required<br>';
			} else {
				$("#form-name-alert").addClass("hide");
			}
			if(this.$data.formEmail.length == 0 || !this.validateEmail(this.$data.formEmail)) {
				$("#form-email-alert").removeClass("hide");
				verified = false;
				message += 'Email is required<br>';
			} else {
				$("#form-email-alert").addClass("hide");
			}
			/*
			if(this.$data.formSubject.length == 0) {
				$("#form-subject-alert").removeClass("hide");
				verified = false;
			} else {
				$("#form-subject-alert").addClass("hide");
			}
			if(this.$data.formMessage.length == 0) {
				$("#form-message-alert").removeClass("hide");
				verified = false;
			} else {
				$("#form-message-alert").addClass("hide");
			}
			*/
			if(this.$data.formDate.length == 0) {
				message += 'Date is required<br>';
				verified = false;
			}
			if(this.$data.formTime.length == 0) {
				message += 'Time is required<br>';
				verified = false;
			}
			if(this.$data.formPhone.length < 10) {
				message += 'Contact is required<br>';
				verified = false;
			}
			if(this.$data.formHeadCount.length == 0) {
				message += 'Number of people is required<br>';
				verified = false;
			}
			var self = this;
			if(verified == false) {
				this.dismissProgressView();
				this.$modal.show('dialog', {
						title: 'SORRY',
						text: message,
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},
						]

					});
				return;
			}

			this.showProgressView("Submitting reservation request");
			var message = this.nl2br(this.$data.formMessage);
			var args = 'name=' + this.$data.formName + '&email=' + this.$data.formEmail + '&subject=' + this.$data.formSubject + '&message=' + message;
			args += '&bookingDate=' + this.$data.formDate;
			args += '&bookingTime=' + this.$data.formTime;
			args += '&phone=' + this.$data.formPhone;
			args += '&headCount=' + this.$data.formHeadCount;

			axios.get(process.env.ROOT_API + '?sheet=' + this.$data.branch + '&type=booking&' +args )
			.then(response => {
				self.dismissProgressView();
				console.log(response);
				var data = response.data;
				if(data.result == 'success') {
					self.$modal.show('dialog', {
						title: 'GOOINARA NARA',
						text: 'Your Booking Request has been successfully submitted. We will contact you as soon as possible. Thank you',
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},

						]

					});
					self.initialiseForm();
				} else {
					self.$modal.show('dialog', {
						title: 'SORRY',
						text: 'Something went wrong. Please try again in a moment. Or contact us by phone.',
						buttons:[
							{
								title:'CLOSE',
								handler:()=>{self.$modal.hide('dialog');}
							},
						]

					});
				}
			})
			.catch(error=>{

				console.log(error);
			});

		},
		nl2br: function(str) {
			if(str == undefined) {
				return "";
			}
			var str = str.split('\n');
			var output = "";
			for(var i = 0 ; i < str.length ; i++) {
				if(i > 0) {
					output += '<br>';
				}
				output +=  str[i];
			}
			return output;
		},
		scrollIntoView(evt) {
	        evt.preventDefault()
	        const href = evt.target.getAttribute('href')
	        const el = href ? document.querySelector(href) : null
	        if (el) {
	          this.$refs.content.scrollTop = el.offsetTop
	        }
	    },
	    moveToLanding: function() {
	    	this.$router.push('/');
	    }
	}

}
</script>
<style>
  a {
    color: black;
  }
  .section {
    width:100%;
    position: relative;
  }
  .main-slide-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.8s ease;
    overflow: hidden;
    visibility: visible;
    opacity: 1;
    position: absolute;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    visibility: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/components/Home.vue